import React, { useEffect, useState } from "react";
import ImportMediaDropzone from "../importMedia/ImportMediaDropzone";

interface UploadedMedia {
  is_new?: boolean;
  imageName?: string;
  media: File[];
  title: string;
}

interface AddMediaModalProps {
  confirmAction: (data: { work_order_id: number; files: File[] }) => void;
  setOpen: (state: { open: boolean }) => void;
  savedMedia: UploadedMedia;
  title: string;
  workOrderId: number;
}

export default function AddMediaModal({
  confirmAction,
  setOpen,
  savedMedia,
  workOrderId,
}: AddMediaModalProps) {
  const [errors, setErrors] = useState({
    media: "",
  });
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  useEffect(() => {
    setUploadedFiles(savedMedia.media || []);
  }, [savedMedia]);

  const validateInputs = () => {
    if (uploadedFiles.length < 1) {
      setErrors({ ...errors, media: "Please upload at least one image" });
      return;
    }
    setOpen({ open: false });
    confirmAction({ work_order_id: workOrderId, files: uploadedFiles });
  };

  const removeImage = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
  };

  return (
    <div className="justify-between">
      <div className="py-1 gap-4 bg-white sm:rounded-xl space-y-4">
        <div className="grid grid-cols-1 gap-4 w-full space-y-4">
          {uploadedFiles.length > 0 ? (
            <div className="space-y-4">
              <h3 className="text-sm font-medium text-gray-700">Uploaded Images ({uploadedFiles.length})</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {uploadedFiles.map((file, index) => (
                  <div key={index} className="relative group">
                    <img
                      src={URL.createObjectURL(file)}
                      alt={file.name || `media ${index + 1}`}
                      title={file.name || `media ${index + 1}`}
                      className="w-full h-32 object-cover rounded-md border border-gray-200"
                    />
                    <button
                      onClick={() => removeImage(index)}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 opacity-0 group-hover:opacity-100 transition-opacity"
                      type="button"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          <ImportMediaDropzone
            buttonTitle="Add Images"
            fileName={""}
            handleInputChange={(img) => {
              const newFiles = Array.isArray(img.file) ? img.file : [img.file];
              setUploadedFiles(prevFiles => [...prevFiles, ...newFiles]);
            }}
            setUploadedImage={(img) => {}}
          />
          {errors.media.length > 0 ? (
            <p className="text-red-600">{errors.media}</p>
          ) : null}
        </div>

        <div className="sm:flex-no-wrap my-auto flex items-center">
          <button
            onClick={validateInputs}
            className="inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center"
          >
            OK
          </button>
          <button
            onClick={() => setOpen({ open: false })}
            className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
